import React from "react";
import styled from "@emotion/styled";

import { responsive } from "../../utils/style";
import { css } from "@emotion/react";
import { useNavigate } from "react-router-dom";
import moment from "moment-timezone";

import Score from "./Score";

const InformCard = ({
  isStart,
  isEnd,
  startDate,
  weeks,
  disable,
  currentScore,
  isInformedThisWeek,
  nextWeekDate,
}) => {
  const navigate = useNavigate();

  return (
    <Container
      isStart={isStart}
      isEnd={isEnd}
      disable={disable}
      onClick={() => {
        if (!disable) navigate("/inform");
      }}
    >
      <Score score={currentScore} />
      <Label isStart={isStart} isEnd={isEnd}>
        กรอกข้อมูล 4 เป้าหมาย
      </Label>
      {!isStart ? (
        <StartDate>{`การแข่งขันเริ่มในวันที่ ${
          startDate
            ? moment(startDate).add("years", 543).format("DD/MM/YYYY")
            : "--/--/----"
        }`}</StartDate>
      ) : isEnd ? (
        <StartDate>{`การแข่งขันสิ้นสุดลงแล้ว`}</StartDate>
      ) : isInformedThisWeek ? (
        <ContentLabel>{`กรอกข้อมูลอีกครั้งได้ในวันที่ ${
          nextWeekDate
            ? moment(nextWeekDate).add("years", 543).format("DD/MM/YYYY")
            : "--/--/----"
        }`}</ContentLabel>
      ) : (
        <InformContent>
          <WeekContainer>
            <ContentLabel>สัปดาห์ที่</ContentLabel>
            <ContentValue>{weeks}</ContentValue>
          </WeekContainer>
        </InformContent>
      )}
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  width: 100%;
  max-width: 911px;
  height: 160px;

  background: ${(props) =>
    props.isStart && !props.isEnd ? "#fc6b4b" : "#E7EAEE"};
  border-radius: 8px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 0 32px;
  margin: 18px 0 18px;

  cursor: ${(props) => (props.disable ? "not-allowed" : "pointer")};

  ${responsive.tablet(css`
    max-width: unset;
    width: calc(100% - 64px);
    height: 120px;

    padding: 0 16px;
  `)}

  ${responsive.mobile(css`
    width: calc(100% - 32px);
    height: 80px;

    padding: 0 16px;
    margin: 8px 0 8px;
  `)}
`;

const Label = styled.span`
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 40px;
  line-height: 44px;

  letter-spacing: -0.02em;

  color: ${(props) => (props.isStart && !props.isEnd ? "#FFFFFF" : "#A0ABBB")};

  ${responsive.tablet(css`
    font-size: 36px;
    line-height: 26px;
  `)}

  ${responsive.mobile(css`
    font-size: 20px;
    max-width: 96px;
  `)}
`;

const StartDate = styled.span`
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;

  text-align: center;

  color: #a0abbb;

  ${responsive.mobile(css`
    font-size: 13px;
    line-height: 14px;
  `)}
`;

const InformContent = styled.div`
  display: flex;
`;

const WeekContainer = styled.div`
  width: 120px;
  height: 88px;
  background: #db5033;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${responsive.tablet(css`
    height: 80px;
  `)}

  ${responsive.mobile(css`
    width: 65px;
    height: 52px;
  `)}
`;

const ContentLabel = styled.span`
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 34px;

  text-align: center;

  color: #ffffff;

  ${responsive.mobile(css`
    font-size: 13px;
    line-height: 18px;
  `)}
`;

const ContentValue = styled.span`
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 32px;
  line-height: 34px;

  text-align: center;

  color: #ffffff;

  ${responsive.mobile(css`
    font-size: 17px;
    line-height: 18px;
  `)}
`;

export default InformCard;
